export default __webpack_public_path__ + "static/hyperledger-1d387b668489ebc39f1b72194d853b99.png";